<div class="intro or-bg-shade">
  <div class="intro__backdrop"></div>

  <img src="assets/icons/orlikfy-header-v2.svg" class="intro__logo" />

  @if (showSkip()) {
    <div (click)="skip()" class="intro__skip or-head-xs or-color-white or-cursor-pointer">Pomiń</div>
  }

  <div class="intro__viewport">
    <div class="intro__track" [style.transform]="trackOffset()">
      @for (slide of slides; track slide.id) {
        <div class="intro__slide">
          <div class="intro__illustration">
            <img [src]="slide.image" [alt]="slide.title" [style.width.%]="imageWidthPercent(slide)" />
          </div>

          <div class="intro__copy or-text-align-center or-px-24-px">
            <div class="or-head-sm or-mb-8-px">{{ slide.title }}</div>
            <div class="or-text-sm or-color-secondary-2">{{ slide.description }}</div>
          </div>
        </div>
      }
    </div>
  </div>

  <div class="intro__footer">
    <button
      type="button"
      (click)="next()"
      class="intro__cta or-align-items-center or-d-flex or-justify-content-center or-cursor-pointer or-head-sm"
      [class.button-primary-style]="currentSlide().ctaVariant === 'gradient'"
      [class.button-secondary-style]="currentSlide().ctaVariant === 'light'"
      [class.or-color-white]="currentSlide().ctaVariant === 'gradient'">
      {{ currentSlide().ctaLabel }}

      <or-icon
        name="chevron-right"
        size="xs"
        class="or-ml-8-px"
        [class.or-color-white]="currentSlide().ctaVariant === 'gradient'" />
    </button>

    <div class="intro__dots or-d-flex or-justify-content-center">
      @for (slide of slides; track slide.id; let i = $index) {
        <div class="intro__dot" [class.intro__dot--active]="i === index()"></div>
      }
    </div>
  </div>
</div>
